import moment from 'moment';
import 'moment/locale/de';
import 'moment/locale/sr';
import i18n from '../../utils/localization/i18n';

export const formatDate = (date: string, formatType = 'DD.MM.YYYY') => {
  return moment(date).locale(i18n.language).format(formatType);
};
export function isCurrentDateInWeek(dateString: string) {
  // Attempt to parse dateString in two formats
  const date = moment(dateString, ['DD.MM.YYYY', 'YYYY-MM-DD'], true).locale(
    i18n.language,
  ); // 'true' for strict parsing
  if (!date.isValid()) {
    throw new Error(
      'Invalid date format. Please use "DD.MM.YYYY" or "YYYY-MM-DD".',
    );
  }

  // Get the start and end of the current week (starting on Monday)
  const startOfWeek = moment().startOf('isoWeek'); // Start of the week (Monday)
  const endOfWeek = moment().endOf('isoWeek'); // End of the week (Sunday)

  // Check if the provided date is within the current week, inclusive of start and end
  return date.isBetween(startOfWeek, endOfWeek, undefined, '[]'); // '[]' makes it inclusive
}
